import { redactPathIds } from '@blockit/web-shared/utils/redactPathIds';
import { RESCHEDULE_TOKEN_PARAM } from '@features/blockit-link/constants';
import { CUSTOM_DOMAIN_TEST_TOKEN_PARAM } from '@features/custom-domain/constants';

export { redactPathIds };

/** Absolute URLs keep their origin and query, minus the link secrets; only the path segments are redacted. */
export const redactLocationIds = (location: string): string => {
  try {
    const url = new URL(location);
    url.pathname = redactPathIds(url.pathname);
    url.searchParams.delete(RESCHEDULE_TOKEN_PARAM);
    url.searchParams.delete(CUSTOM_DOMAIN_TEST_TOKEN_PARAM);
    return url.toString();
  } catch {
    return redactPathIds(location);
  }
};
